
import { useTheme } from "../../context/ThemeContext";
import CommonCard from "../ui/CommonCard/CommonCard";
import classes from "./LoginCard.module.css";

const loginOptions = [
  {
    image: "/google.svg",
    tag: "google",
  },
  {
    image: "/microsoft.svg",
    tag: "microsoft",
  },
];

const LoginCard = ({ children, login, className }) => {
  const {darkMode} = useTheme()
  return (
    <CommonCard className={` ${classes.loginCard} ${className}`}>
      <div className="d-flex flex-column align-items-center">
        <img src="PROPTRADING.FUN.svg"  alt="logo"/>
      </div>
      {children}
    </CommonCard>
  );
};

export default LoginCard;
